/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_LeadInputs */

const cs_model_lead = /** @type {(inputs: Model_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead`)
};

const en_model_lead = /** @type {(inputs: Model_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead`)
};

/**
* | output |
* | --- |
* | "Lead" |
*
* @param {Model_LeadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const model_lead = /** @type {((inputs?: Model_LeadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_LeadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_model_lead(inputs)
	return cs_model_lead(inputs)
});